(() => {
  const targetId = 'ContactForm';
  const buttonId = 'js-submit-button';
  const target = document.getElementById(targetId);
  const $target = $(`#${targetId} :input`);
  const button = document.getElementById(buttonId);
  const checkBoxElementNameList = [
    'contact[当社製品をどちらでお知りになりましたか]',
    'contact[ご来場の目的をお選びください]',
  ];

  const googleAppsScriptUrl =
    'https://script.google.com/macros/s/AKfycbw7l6Sn-n6dV9x3cXWePDpwQ9Zgq55RW8VljyzUObRkX9oSUtGfzDfPvVkj9121rxxh/exec';

  /**
   * @param {array} formArray [{name: 'name', value: 'value'}]
   * @return {object}  {'name': 'value'}
   */
  const objectifyForm = (formArray) => {
    const returnObject = {};
    for (let i = 0; i < formArray.length; i++) {
      if (checkBoxElementNameList.includes(formArray[i]['name'])) {
        if (!returnObject[formArray[i]['name']]) {
          returnObject[formArray[i]['name']] = formArray[i]['value'] + ',';
        } else {
          returnObject[formArray[i]['name']] += formArray[i]['value'] + ',';
        }
      } else {
        returnObject[formArray[i]['name']] = formArray[i]['value'];
      }
    }
    return returnObject;
  };

  const getRedirectUrl = () => {
    const url = location.href;
    const urlParam = location.search.substring(1);
    if (!urlParam) {
      return `${url}?contact_posted=true`;
    }
    if (!urlParam.match(/contact_posted=true/)) {
      return `${url}&contact_posted=true`;
    }
    return url;
  };

  const redirect = (url) => {
    location.href = url;
  };

  window.addEventListener('DOMContentLoaded', () => {
    if (!target) {
      return;
    }
    target.addEventListener('submit', (event) => {
      console.log("送信されました");
      event.preventDefault();
      button.disabled = true;
      const formObject = objectifyForm($target.serializeArray());
      const postParameter = {
        method: 'POST',
        mode: 'no-cors',
        'Content-Type': 'text/plain',
        keepalive: true,
        body: JSON.stringify(formObject),
      };
      fetch(googleAppsScriptUrl, postParameter).finally(() => {
        redirect(getRedirectUrl());
      });
    });
  });

  const getTitle = () => {
    const param = location.search;
    document.getElementById('urlParam').value = param;
  };

  getTitle();
})();
